"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditType = void 0;
/**
 * Edit Types
 *
 * Part I, Section 26
 */
var EditType;
(function (EditType) {
    EditType["MainAsset"] = "Main Asset";
    EditType["ShorterOrLongerVersion"] = "Shorter Or Longer Version";
    EditType["PermittedChanges"] = "Permitted Changes";
    EditType["PaidEdits"] = "Paid Edits";
    EditType["AddressableEdits"] = "Addressable Edits";
})(EditType || (exports.EditType = EditType = {}));
//# sourceMappingURL=edit-types.js.map